/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

export const CREATE_PRODUCT = gql`
    mutation Mutation(
        $name: String!
        $desc: [DescSchemaInput]
        $assets: AllAssetsSchemaInput
        $attrs: [AttrSchemaInput]!
        $dateAttrs: [DateAttrSchemaInput]
    ) {
        createProduct(
            name: $name
            desc: $desc
            assets: $assets
            attrs: $attrs
            date_attrs: $dateAttrs
        ) {
            _id
            name
            lname
            description
            ingredients
            instructions
            subtitle
            images
            desc {
                lang
                val
                desc_type
            }
            assets {
                imgs {
                    height
                    src
                    width
                    asset_type
                }
                others {
                    height
                    src
                    width
                    asset_type
                }
            }
            gtins {
                _id
                name
            }
        }
    }
`;
